<template>
  <div class="loading__wrapper" v-if="loading">
    <div class="loading__inner">
      <img class="image" src="@/assets/image/loading.png" alt="loading" />
      <div class="text">loading</div>
    </div>
  </div>
</template>

<script>
import { inject } from "vue";

export default {
  name: "Loading",
  setup() {
    const { loading } = inject("commons");

    return {
      loading,
    };
  },
};
</script>

<style scoped>
.loading__wrapper {
	background-color: #fff;
	height: 100vh;
	left: 0;
	position: fixed;
	top: 0;
	width: 100vw;
	z-index: 100;
}

.loading__inner {
	left: 50%;
	position: absolute;
	top: 50%;
	transform: translate(-50%, -50%);
}

.image {
	width: 172px;
}

.text {
	font-family: "aw-conqueror-didot", serif;
	font-size: 1.5rem;
	margin-top: 40px;
	text-align: center;
	text-transform: capitalize;
}
</style>

